<template>
  <!-- <div id="kt_header" class="kt-header kt-grid__item  kt-header--fixed " data-ktheader-minimize="on" kt-hidden-height="70" style=""> -->
  <div class="kt-container  kt-container--fluid ">
    <!-- begin:: Brand -->
    <div id="kt_header_brand" class="kt-header__brand ">
      <div class="kt-header__brand-logo">
        <router-link to="/">
          <img
            alt="Logo"
            src="../../../public/assets/media/icons/eli-logo-white.svg"
            class="logo"
            @click="trackCustomEvent({ action: 'clicked', target: 'logo_header', linkTo: 'overview' })"
          >
        </router-link>
      </div>
      <!-- <div v-if="isDropdown" class="kt-header__brand-nav">
        <div v-if="allProject.projects" class="dropdown">
          <button type="button" class="btn btn-outline-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
            {{ projectName ? projectName.name : 'Project' }}
          </button>
          <div class="dropdown-menu dropdown-menu-fit dropdown-menu-project">
            <ul class="kt-nav kt-nav--bold kt-nav--sm-space">
              <li
                v-for="project in allProject.projects"
                :key="project.id"
                class="kt-nav__item"
                @click="trackCustomEvent({ inPage: routeName, action: 'clicked', target: 'projects_list_header', linkTo: `dashboard/${project.id}` }); selectedProject()"
              >
                <router-link :to="`/dashboard/${project.id}`" class="kt-nav__link active">
                  <div>
                    <span class="kt-nav__link-text"> {{ project.name }} </span>
                    <div class="kt-widget1__sub kt-label-font-color-1">
                      {{ project.id.substr(0,10) }}
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div> -->
    </div>
    <!-- end:: Brand -->

    <!-- begin:: Header Topbar -->
    <div v-if="!isTokenDebugger" class="kt-header__topbar">
      <!--begin: User bar -->
      <div class="kt-header__topbar-item kt-header__topbar-item--user">
        <div class="kt-header__topbar-wrapper" data-toggle="dropdown" data-offset="10px,0px" aria-expanded="false">
          <span
            v-if="!getProfilePicture || getProfilePicture.match(/(\w*default\w*)\.(png|jpg|jpeg)/i)"
            class="kt-badge kt-badge--dark kt-badge--lg kt-badge--bolder"
            @click="trackCustomEvent({ action: 'clicked', target: 'profile_picture_header' })"
          >
            {{ getEmail[0].toUpperCase() }}
          </span>
          <img
            v-else
            alt="Pic"
            :src="getProfilePicture"
            class="proilfe-picture"
            @click="trackCustomEvent({ action: 'clicked', target: 'profile_picture_header' })"
          >
          <!-- <span class="kt-header__topbar-icon kt-bg-danger kt-hidden"><b>S</b></span> -->
          <span
            class="kt-header__topbar-username kt-visible-desktop kt-margin-l-10"
            style="color: white"
            @click="trackCustomEvent({ action: 'clicked', target: 'profile_email_header' })"
          >
            {{ getEmail }}
          </span>
        </div>
        <div class="dropdown-menu dropdown-menu-fit dropdown-menu-left dropdown-menu-anim dropdown-menu-sm">
          <ul class="kt-nav">
            <li
              class="kt-nav__item"
              @click="trackCustomEvent({ action: 'clicked', target: 'myprofile_menu_header', linkTo: 'profile' })"
            >
              <router-link to="/profile" class="kt-nav__link">
                <i class="kt-nav__link-icon flaticon2-user-outline-symbol" />
                <span class="kt-nav__link-text">My Profile</span>
              </router-link>
            </li>
            <li
              class="kt-nav__item"
              @click="trackCustomEvent({ action: 'clicked', target: 'logout_menu_header', linkTo: 'login' })"
            >
              <router-link to="#" class="kt-nav__link">
                <i class="kt-nav__link-icon la la-sign-out" />
                <span class="kt-nav__link-text" @click="logout">Log Out</span>
              </router-link>
            </li>
          </ul>
          <!--end::Nav-->
        </div>
      </div>
    </div>
    <!--end: User bar -->
  </div>
  <!-- end:: Header Topbar -->
  <!-- </div> -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      getUserId: 'user/getUserId',
      getUserDetail: 'user/getUserDetail',
      allProject: 'project/getAllProject',
      getProjectDetail: 'project/getProjectDetailState',
      getName: 'user/getName',
      getEmail: 'user/getEmail',
      getProfilePicture: 'user/getProfilePicture',
      getDefaultProfilePicture: 'user/getDefaultProfilePicture',
      getWebServiceConnector: 'user/getWebServiceConnector',
      getSessionId: 'user/getSessionId'
    }),
    projectName () {
      return this.getProjectDetail[this.$route.params.projectId]
      // return this.allProject.projects.filter(project => project.id === this.$route.params.projectId)[0]
    },
    isDropdown () {
      return this.$route.name !== 'overview' && this.$route.name !== 'tokendebugger'
    },
    isTokenDebugger () {
      return this.$route.name === 'tokendebugger'
    }
  },
  mounted () {
    if (this.$route.name !== 'overview' && this.$route.name !== 'tokendebugger') {
      this.loadAllProject()
    }
  },
  methods: {
    ...mapActions({
      loadAllProject: 'project/loadAllProject',
      logoutRequest: 'user/logout',
      clearProjectDetailRequest: 'project/clearProjectDetail',
      trackCustomEvent: 'user/trackCustomEvent'
    }),
    async logout () {
      await this.logoutRequest()
      this.$router.push({ path: '/login' })
    },
    selectedProject () { // log
      const sessionId = this.getSessionId
      const userId = this.getUserId
      const webServiceConnector = this.getWebServiceConnector
      webServiceConnector.loggerFluentd({
        '"userId"': userId,
        '"sessionId"': sessionId,
        '"inpage"': '/overview',
        '"action"': 'click',
        '"element"': 'selected-dropdown-project'
      })
    },
    async clearProjectDetail () {
      //  TODO FOR DEV ONLY
      // await this.clearProjectDetailRequest()
      console.log('clear project detail')
    }
  }
}
</script>

<style scoped>
  .kt-header .kt-header__top {
    height: 60px;
  }

  .dropdown-menu-project {
    min-width: 200px;
  }
  .kt-header__topbar .kt-header__topbar-item .kt-header__topbar-wrapper {
    align-items: center;
  }
  .logo {
    height: 40px;
  }
  .proilfe-picture {
    object-fit: cover;
  }
</style>
